import { Controller } from "@hotwired/stimulus"

let formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
})

// Connects to data-controller="envelope-filler"
export default class extends Controller {
  static targets = ["fillBalance", "remainingBalance", "envelope", "submitButton"]
  static values = {
    balance: Number
  }

  autofill() {
    this.envelopeTargets.forEach(target => {
      let value = target.dataset.autofillBalance
      if (parseFloat(value) < 0)
        target.value = "0.00"
      else
        target.value = value
    })

    this.updateFillAmount()
  }

  updateFillAmount() {
    let total = this.envelopeBalance
    let remaining = this.balanceValue - this.envelopeBalance
    let disabled = remaining < 0

    this.fillBalanceTarget.innerHTML = formatter.format(total)
    this.remainingBalanceTarget.innerHTML = formatter.format(remaining)
    this.remainingBalanceTarget.classList.toggle("text-red-600", disabled)
    this.submitButtonTarget.disabled = disabled
  }

  get envelopeBalance() {
    return this.envelopeTargets.reduce((acc, envelope) => {
      return acc + (parseFloat(envelope.value) || 0)
    }, 0)
  }
}
